import { render, staticRenderFns } from "./TextAreaElement.vue?vue&type=template&id=c930709c&scoped=true&"
import script from "./TextAreaElement.vue?vue&type=script&lang=js&"
export * from "./TextAreaElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c930709c",
  null
  
)

export default component.exports